import React,{useState, useEffect,useRef} from 'react'

import { MyBridgeLogoMain } from '@mybridge/icons/MyBridgeLogo';
import { Modal, ModalContent, ModalOverlay,ModalBody } from '@mybridge/ui/modal';
import { ModalreelDisplay } from 'v4/components/post/modal-Reel-display';
import { PostBoxFooter } from 'v4/components/post/footer';
import { PostBoxInsightPlate } from 'v4/components/post/insight-plate';
import { ReelBoxFooterActions } from 'v4/components/post/reel-footer-actions';

import { Box, HStack, Stack, VStack } from '@mybridge/ui/layout';
import { CloseButton } from '@mybridge/ui';
import { Spinner } from '@mybridge/ui/spinner';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { Skeleton } from '@mybridge/ui/skeleton';

import Link from 'next/link';

import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';
import { background } from '@chakra-ui/react';

import styles from './reelContainer.module.scss';

const DashboardReelModal = ({
  onClose,
  postsData,
  fetchNext,
  hasMore = false,
  postIndex = 0,
  postMediaIndex = 0,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reelsData, setReelsData] = useState(postsData);
  const [activeIndex, setActiveIndex] = useState(postIndex);
  const [showMediaPost, setShowMediaPost] = useState(false);
  const playerRefs = useRef([]);

  const postBoxContext = usePostBoxContext({
    post: reelsData[activeIndex],
    initialFetchComments: true,
  });
  const { refetch, refetchComments, post, hasMedia } = postBoxContext ?? {};

  useEffect(() => {
    if (activeIndex !== postIndex) {
      postBoxContext.post = reelsData[activeIndex];
      refetch();
    }
    if(activeIndex >= reelsData.length -2 && hasMore){
      fetchNext();
    }
  }, [activeIndex,expanded, loading]);

  useEffect(() => {
    // Pause all videos
    if (playerRefs?.current?.length > 0) {
      playerRefs.current.forEach((playerRef, index) => {
        if (playerRef && playerRef.getInternalPlayer) {
          playerRef.getInternalPlayer().pause();
        }
      });
    }

    // Play the current video
    const currentRef = playerRefs.current[activeIndex];
    if (currentRef && currentRef?.getInternalPlayer) {
      currentRef?.getInternalPlayer()?.play();
    }
  }, [activeIndex]);


  const handlechangeSwipe = (slider) => {
    setActiveIndex(slider.activeIndex);
  }

  const setPlayerRef = (index) => (ref) => {
    playerRefs.current[index] = ref;
  };

  const handleCommentClicked = () => {
    setExpanded(!expanded);
  };

  const handleClose = () => {
    setExpanded(false);
    setLoading(false);
    setReelsData([]);
    onClose();
  }

  return (
    <>
      <Modal isOpen onClose={handleClose} size="full">
        <ModalOverlay />
        <ModalContent style={{ border: '0px' }}>
          <PostBoxContext.Provider
            value={{
              ...(postBoxContext ?? {}),
            }}
            post={reelsData[postIndex]}
          >
            <ModalBody
              p={0}
              className="reelModalContainer"
            >
              {/* {loading ? (
                <HStack
                  pos="absolute"
                  top="0"
                  left="0"
                  w="100%"
                  h="100%"
                  alignItems="center"
                  justifyContent="center"
                  zIndex="5"
                  bg="black"
                >
                  <Spinner size="xl" color="white" />
                </HStack>
              ) : (
                ''
              )} */}

              <HStack
                flexDirection={['column', 'column', 'row']}
                alignItems="stretch"
                spacing={0}
                minH={'100vh'}
                pos="relative"
              >
                {/* Headear created */}
                <HStack
                  pos="fixed"
                  top="0"
                  left="0"
                  right="0"
                  zIndex="2"
                  px={2}
                  maxW={'100px'}
                >
                  <HStack bg="transparent" color="white">
                    {!isMobile && <CloseButton onClick={onClose} />}
                  </HStack>
                  <Box p={2}>
                    <Link href="/" as="/">
                      <MyBridgeLogoMain width={isMobile ? '30px' : '44px'} />
                    </Link>
                  </Box>
                </HStack>

                <HStack
                  // flex={"1 1 80%"}
                  flex={1}
                  bg="black"
                  minH='100vh'
                  w="100%"
                  maxW={['100%', '100%', expanded ? '100%' : '100%']}
                  position="sticky"
                  top={0}
                  justifyContent="center"
                  spacing={0}
                  overflowY="hidden"
                  // _hover={{ overflowY: 'auto' }}
                >
                  <div
                    // className={
                    //   expanded ? styles.container : styles.expendedContainer
                    // }
                  >
                    <Swiper
                      navigation
                      modules={[Navigation]}
                      onActiveIndexChange={handlechangeSwipe}
                      slidesPerView={1}
                    >
                      {reelsData?.map?.((post, index) => (
                        <SwiperSlide key={index}>
                          <div className={styles.mainReelSection}>
                            <div className={styles.mediaContainer}>
                              <ModalreelDisplay
                                reelIndex={index}
                                activeIndex={activeIndex}
                                setPlayerRef={setPlayerRef(index)}
                                post={post}
                                isReel={true}
                                fullScreen={expanded}
                              />
                            </div>
                            <div className={styles.footerAction}>
                              <PostBoxFooter>
                                {post?.id && (
                                  <div className={styles.childContainer}>
                                    <PostBoxInsightPlate
                                      isActive={expanded}
                                      handleCommentClicked={
                                        handleCommentClicked
                                      }
                                      isReel={true}
                                    />
                                    <ReelBoxFooterActions
                                      isActive={expanded}
                                      handleCommentClicked={
                                        handleCommentClicked
                                      }
                                      isReel={true}
                                    />
                                  </div>
                                )}
                              </PostBoxFooter>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </HStack>

                <Box
                  flex={['auto', 'auto', 1]}
                  maxW={expanded ? '31%' : 0}
                  maxH="100vh"
                  overflowY="auto"
                >
                  {post?.id ? (
                    <DashboardPostBox
                      post={post}
                      isInFrame={true}
                      showMedia={
                        post?.type === 3 || showMediaPost ? true : false
                      }
                      showComments={true}
                      context={postBoxContext}
                    />
                  ) : (
                    <Skeleton
                      maxW={'100%'}
                      maxH="100%"
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Spinner />
                    </Skeleton>
                  )}
                </Box>
              </HStack>
            </ModalBody>
          </PostBoxContext.Provider>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DashboardReelModal;
